import { useEffect, useMemo, useState } from 'react'
import useCustomEndpoint, { VALID_ENDPOINTS } from '@/hooks/useCustomEndpoint'
import { isEmpty, orderBy, snakeCase } from 'lodash'
import { wrap } from '@popmotion/popcorn'

const getProperties = (data) => {
  if (isEmpty(data)) return []

  const properties = []

  data?.forEach((item, index) => {
    const hotelName = item?.select_label

    const name = hotelName

    const property = {
      index,
      property_ID: item?.hotel_ID,
      isFirst: index === 0,
      name: name,
      label: name,
      value: snakeCase(name),
      images: item?.hotelImages,
      siteUrl: item?.site_url,
      totalImages: item?.hotelImages?.length,
      guestRooms: item?.guestRooms || '',
      restaurants: item?.restaurants || '',
      minsFromAirport: item?.minsFromAirport || '',
      order: item?.order,
    }

    properties.push(property)
  })

  if (isEmpty(properties)) return []

  return properties
}

const getPropertyData = (item) => {
  if (isEmpty(item)) return {}

  const hotelName = item?.select_label

  const name = hotelName

  return {
    name: name,
    label: name,
    value: snakeCase(name),
    images: item?.hotelImages,
    siteUrl: item?.site_url,
    totalImages: item?.hotelImages?.length,
    guestRooms: `${item?.guestRooms} Guest Rooms`,
    restaurants: `${item?.restaurants} Restaurants`,
    minsFromAirport: `${item?.minsFromAirport} mins from airport`,
  }
}

export default function useOurProperties() {
  const [properties, setProperties] = useState([])
  const { data: allData, loading: allLoading } = useCustomEndpoint({
    type: VALID_ENDPOINTS.ourProperties,
    fetchOnMount: true,
  })
  const {
    data: dataHotelSelected,
    loading: loadingHotelSelected,
    reFetchData: fetchPropertyById,
  } = useCustomEndpoint({
    type: VALID_ENDPOINTS.ourProperties,
    fetchOnMount: false,
  })

  const [[imageCount, direction], setImageCount] = useState([0, 0])

  const [currentProperty, setCurrentProperty] = useState({})

  const activeImageIndex = wrap(0, currentProperty?.totalImages, imageCount)

  const swipeToImage = (swipeDirection) => {
    setImageCount([imageCount + swipeDirection, swipeDirection])
  }

  const dragEndHandler = (dragInfo) => {
    const draggedDistance = dragInfo.offset.x
    const swipeThreshold = 100
    const swipeThresholdNegative = -100

    if (draggedDistance > swipeThreshold) {
      swipeToImage(-1)
    } else if (draggedDistance < swipeThresholdNegative) {
      swipeToImage(1)
    }
  }

  const onChangeHotel = (item) => {
    if (isEmpty(item)) return

    // if (item?.isFirst) {
    //   const property = properties[0]

    //   setCurrentProperty(property)
    // } else {
    fetchPropertyById({
      type: VALID_ENDPOINTS.ourProperties,
      params: { hotel_ID: item?.property_ID },
    }).then((response) => {
      const propertyData = getPropertyData(response[0])

      const result = !isEmpty(propertyData) ? propertyData : {}

      setCurrentProperty(result)

      setImageCount([0, 0])
    })
    // }
  }

  const currentImage = useMemo(() => {
    if (isEmpty(currentProperty)) return {}

    const _image = currentProperty?.images[activeImageIndex]

    if (isEmpty(_image)) return {}

    return _image
  }, [currentProperty, activeImageIndex])

  useEffect(() => {
    if (isEmpty(allData)) return

    const _properties = getProperties(allData)

    const orderedData = orderBy(_properties, ['order'], ['asc'])

    onChangeHotel(orderedData[0])

    setProperties(orderedData)
  }, [allData])

  return {
    currentProperty,
    allLoading,
    loadingHotelSelected,
    setCurrentProperty,
    properties,
    swipeToImage,
    direction,
    activeImageIndex,
    dragEndHandler,
    imageCount,
    currentImage,
    dataHotelSelected,
    onChangeHotel,
  }
}
